<template>
  <section class="hero-xv" ref="root">
    <img src="@/assets/por.webp" alt="" class="bg" ref="bg" />
    <div class="vignette" ref="vignette"></div>

    <div class="copy" ref="copy">
      <span class="misxv" ref="misxv">MIS XV</span>
      <h1 class="nombre" ref="nombre">Kamilah</h1>
      <div class="subblock" ref="sub">
        <span class="line"></span>
        <span class="apellido">ZOE</span>
        <span class="line"></span>
      </div>
    </div>

    <div class="reflection" ref="reflection">
      <img src="@/assets/monse.jpg" alt="" class="bg-reflect" />
      <div class="fade"></div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaXVExacta',
  setup() {
    const root = ref(null)
    const nombre = ref(null)
    const sub = ref(null)
    const misxv = ref(null)
    const copy = ref(null)
    const vignette = ref(null)
    const reflection = ref(null)
    const bg = ref(null)

    const split = (el) => {
      const txt = el.textContent || ''
      el.textContent = ''
      ;[...txt].forEach(c => {
        const s = document.createElement('span')
        s.className = 'char'
        s.textContent = c
        el.appendChild(s)
      })
    }

    const animate = () => {
      // Estados iniciales
      gsap.set(root.value, { opacity: 0, y: 20 })
      gsap.set(vignette.value, { opacity: 0 })
      gsap.set(copy.value, { opacity: 0, y: 24 })
      gsap.set(reflection.value, { opacity: 0, y: 16 })
      gsap.set('.char', { opacity: 0, y: 56 })
      gsap.set(sub.value, { opacity: 0, y: 18 })

      // 🔥 Imagen de fondo: MUCHO más desplazamiento desde abajo
      gsap.set(bg.value, { opacity: 0, y: 260 })

      const lines = sub.value?.querySelectorAll('.line') || []
      gsap.set(lines, { scaleX: 0, transformOrigin: 'center' })

      const tl = gsap.timeline({ defaults: { ease: 'power4.out' } })
      tl.to(root.value, { opacity: 1, y: 0, duration: 0.7 })
        .to(bg.value,   { opacity: 1, y: 0, duration: 1.6 }, '-=0.55') // ← desplazamiento más notorio
        .to(vignette.value, { opacity: 1, duration: 0.6 }, '-=1.0')
        .to(copy.value, { opacity: 1, y: 0, duration: 0.65 }, '-=0.7')
        .to('.char',    { opacity: 1, y: 0, duration: 0.7, stagger: 0.03 }, '-=0.5')
        .to(sub.value,  { opacity: 1, y: 0, duration: 0.55 }, '-=0.55')
        .to(lines,      { scaleX: 1, duration: 0.6, stagger: 0.06 }, '-=0.55')
        .to(reflection.value, { opacity: 1, y: 0, duration: 0.65 }, '-=0.55')
    }

    onMounted(async () => {
      await nextTick()
      split(nombre.value)

      const io = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.25 })

      if (root.value) io.observe(root.value)
    })

    onBeforeUnmount(() => gsap.killTweensOf('*'))

    return { root, nombre, sub, misxv, copy, vignette, reflection, bg }
  }
}
</script>

<style scoped>
.hero-xv{
  position: relative;
  width: 100%;
  height: 100vh;
  margin-top:-60px;
  overflow: hidden;
  background:#000;
}

/* Foto a pantalla completa (sin blur ni cambios de color) */
.bg{
  position:absolute; inset:0;
  width:100%; height:100%;
  object-fit:cover;
  transform: scale(1.01);
  filter: contrast(1.05) saturate(1.05);
}

/* Gradiente superior (dos valores) */
.vignette{
  position:absolute; inset:0;
  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.55) 0%,
    rgba(0,0,0,0.00) 35%
  );
  pointer-events:none;
}

/* Texto centrado */
.copy{
  position:absolute;
  top:4%;
  left:50%;
  transform:translateX(-50%);
  text-align:center;
  color:#fff;
  z-index:3;
  width:min(92vw, 520px);
}
.misxv{
  display:inline-block;
  font-family: 'Poppins', sans-serif;
  letter-spacing:.35em;
  font-size:.9rem;
  opacity:.95;
}
.nombre{
  margin:.2rem 0 0 0;
  line-height: .9;
  font-family:'titulos', cursive;
  font-size: 98px !important;
  font-weight: 400;
  color:#fff;
  text-shadow: 0 2px 8px rgba(0,0,0,.35);
  pointer-events:none;
}
.nombre .char{ display:inline-block; }

.subblock{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:.75rem;
  margin:.4rem 0 .2rem;
}
.apellido{
  font-family:'Poppins', sans-serif;
  letter-spacing:.35em;
  font-size: 30px;
}
.line{
  width:70px; height:1px; background:#fff8;
}

/* Reflejo inferior */
.reflection{
  position:absolute; left:0; right:0; bottom:-2px;
  height:22vh; overflow:hidden; z-index:2;
}
.bg-reflect{
  position:absolute; left:0; right:0; bottom:0;
  width:100%; height:100vh;
  object-fit:cover;
  transform: scaleY(-1);
  transform-origin: bottom center;
}
.reflection .fade{
  position:absolute; inset:0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.715), rgba(0, 0, 0, 0.116) 70%, rgba(0, 0, 0, 0.249));
}

.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #d9d2f1;
  z-index: 2;
  pointer-events: none;
}
</style>

